import React, {useRef} from 'react';
import {Trans, useTranslation} from 'next-i18next';
import type {IconButtonProps} from '@tempo/core';
import {IconButton, useDisclosure, Text, Portal, Box, Link} from '@tempo/core';
import {Icon} from '@tempo/icons';
import Popover, {
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
} from '@components/Popover';

const UPCInfoTooltip = (props: Omit<IconButtonProps, 'aria-label'>) => {
	const {t} = useTranslation('d4c');
	const {isOpen, onOpen, onClose} = useDisclosure();
	const closeTimeout = useRef<number>(undefined);

	const handleOpen = () => {
		if (typeof closeTimeout.current !== 'undefined') {
			clearTimeout(closeTimeout.current);
		}

		onOpen();
	};

	const handleClose = () => {
		if (typeof closeTimeout.current !== 'undefined') {
			clearTimeout(closeTimeout.current);
		}

		closeTimeout.current = window.setTimeout(() => {
			onClose();
			clearTimeout(closeTimeout.current);
			closeTimeout.current = undefined;
		}, 200);
	};

	return (
		<Popover
			isOpen={isOpen}
			onClose={onClose}
			autoFocus={false}
			placement={'bottom-end'}
			trigger="hover"
		>
			<PopoverTrigger>
				<IconButton
					variant="ghost"
					aria-label={t('requestaccesstooltip_text_seeupcinfo_d4c-web')}
					size="xs" // TODO xs does not exist in Tempo, but if we use small, it doesn't work with the tooltip
					{...props}
					icon={<Icon boxSize={4} />}
					onMouseEnter={handleOpen}
					onMouseLeave={handleClose}
					onClick={onOpen}
				/>
			</PopoverTrigger>
			<Portal>
				<PopoverContent onMouseEnter={handleOpen} onMouseLeave={handleClose}>
					<Box color="text.neutral.primary.default">
						<PopoverBody>
							<Text mb={2} fontWeight="bold">
								{t('requestaccess_title_whatisaupc_d4c-web')}
							</Text>
							<Text>
								<Trans
									components={{
										LinkTo: (
											<Link
												href="https://deezerforcreators.zendesk.com/hc/en-gb/articles/6328093844893-How-To-Get-Access-To-Deezer-For-Creators"
												isExternal={true}
												variant="deezer"
											/>
										),
									}}
								>
									{t('requestaccess_text_whatisaupc_d4c-web')}
								</Trans>
							</Text>
						</PopoverBody>
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};

export default UPCInfoTooltip;
